var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("AppBreadCrumb", { attrs: { paths: _vm.paths, select: true } }),
      _vm._v(" "),
      _c("CustomerPlans", {
        attrs: { "is-admin": false, type: _vm.type },
        on: { "go-back": _vm.goBack },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }